import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  lang: localStorage.getItem('lang') || 'en',
  logInError: false,
  userProfile: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: true,
  notifications: [],
  version: null,
  config: {
    messagesStatsUrl: '',
    templatesApiUrl: '',
    authApiUrl: '',
  },
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
